import ReportPreview from './container/index';

export default ReportPreview;



// WEBPACK FOOTER //
// ./src/views/ReportPreview/index.js